import React, {useState} from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import {useTranslation} from 'react-i18next';
import TableFunction from '../../../../../components/table/TableFunction';
import {useSelector} from 'react-redux';
import {getDateFormat} from '../../../../../Apis/functions';

const AssignFreeCardTable = ({ data, selectedList, setSelectedList, excludedId, setIsAllChecked }) => {
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [tableId, setTableId] = useState("tbl_afct_table");

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} className='first_head'>{t('number')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('facility_code')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('format')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('created_at')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if (!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let auxData = data.filter(item => !excludedId.some(excluded => excluded.id === item.id));
        let body = auxData.map((item) => {
            return (
                <>
                    <CustomTd className='first-column'>{item?.number}</CustomTd>
                    <CustomTd>{item?.facilityCode}</CustomTd>
                    <CustomTd>{item?.cardTypeName}</CustomTd>
                    <CustomTd>
                        {getDateFormat(item?.createdAt, true)}
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };


    const { thead, tbody, handleCheckboxChange, handleDeleteAll } = TableFunction({
        selectedList,
        setSelectedList: setSelectedList,
        data: { content: data },
        getTbody: getTbody,
        getThead: getThead,
        setIsAllChecked
    });


    return {
        t, DEV,
        thead, tbody,
        tableId,
        handleDeleteAll,
        handleCheckboxChange
    };

}
export default AssignFreeCardTable;
